import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing, palette }) => ({
  errorMessage: {
    color: `${palette.error.main} !important`,
    marginTop: spacing(8),
    fontSize: spacing(10.5),
    fontFamily: 'Roboto',
    height: spacing(10),
    display: 'flex !important',
  },
}))
